import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

import { getCellValueInCurrentColumn } from "../../utilities/agGridUtils";

import type { PlanEditorRowData } from "../../types/values.types";

/**
 * Cell renderer for Pre-Existing Condition months detail
 * Displays the formatted value (e.g., "12/06" or "12/06/03")
 * Shows "-" when the field is disabled based on preExistingConditionType
 */
export const PreExistingConditionMonthsRenderer: React.FC<
  ICellRendererParams<PlanEditorRowData, string>
> = (props) => {
  const { value, data } = props;

  // Check if this cell has editableWhen configuration
  const editableWhen = data?.benefit?.editableWhen;

  if (editableWhen) {
    // Get the value from the dependent cell in the same column
    const dependentValue = getCellValueInCurrentColumn(
      props,
      editableWhen.dependsOn,
    );

    // Check if the dependent value disables this cell
    const isDisabled =
      dependentValue === undefined ||
      dependentValue === null ||
      dependentValue === "" ||
      editableWhen.disabledValues?.includes(dependentValue as string);

    // Return "-" for disabled cells
    if (isDisabled) {
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            px: 1,
          }}
        >
          <Typography variant="body-medium">-</Typography>
        </Box>
      );
    }
  }

  // For enabled cells, show "-" if value is empty/null
  if (!value) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          px: 1,
        }}
      >
        <Typography variant="body-medium">-</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        px: 1,
      }}
    >
      <Typography variant="body-medium">{value}</Typography>
    </Box>
  );
};
